import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalogApi, type Catalog, type Collection } from '../../api/catalog';

export function CollectionBuilderPage() {
  const [catalogs, setCatalogs] = useState<Catalog[]>([]);
  const [collections, setCollections] = useState<Collection[]>([]);
  const [catalogId, setCatalogId] = useState('');
  const [name, setName] = useState('');
  const [productIds, setProductIds] = useState('');
  const [error, setError] = useState('');

  const reload = () => {
    void catalogApi
      .listCollections(catalogId ? { catalog_id: catalogId, type: 'static' } : { type: 'static' })
      .then(setCollections)
      .catch((e) => setError(String(e)));
  };

  useEffect(() => {
    void catalogApi.listCatalogs().then((items) => {
      setCatalogs(items);
      if (items[0]?.id) setCatalogId(items[0].id);
    });
  }, []);

  useEffect(() => {
    reload();
  }, [catalogId]);

  const create = async () => {
    if (!name.trim()) return;
    try {
      await catalogApi.createCollection({
        catalog_id: catalogId || undefined,
        name: name.trim(),
        type: 'static',
        product_ids: productIds.split(',').map((s) => s.trim()).filter(Boolean),
      });
      setName('');
      setProductIds('');
      reload();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Create failed');
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/catalog" className="text-sm text-slate-600 hover:underline">← Catalogs</Link>
      <h1 className="mt-4 text-2xl font-semibold">Collection Builder</h1>
      <p className="mt-1 text-sm text-slate-600">Create static product collections.</p>
      <div className="mt-6 space-y-3 rounded-xl border bg-white p-6">
        <select value={catalogId} onChange={(e) => setCatalogId(e.target.value)} className="w-full rounded-lg border px-3 py-2 text-sm">
          {catalogs.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Collection name" className="w-full rounded-lg border px-3 py-2 text-sm" />
        <input
          value={productIds}
          onChange={(e) => setProductIds(e.target.value)}
          placeholder="Product IDs (comma-separated)"
          className="w-full rounded-lg border px-3 py-2 text-sm"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button type="button" onClick={() => void create()} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">
          Create collection
        </button>
      </div>
      <div className="mt-6 overflow-x-auto rounded-xl border bg-white">
        <table className="min-w-full text-sm">
          <thead className="border-b bg-slate-50 text-left text-slate-600">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Products</th>
              <th className="px-4 py-3">Updated</th>
            </tr>
          </thead>
          <tbody>
            {collections.map((col) => (
              <tr key={col.id} className="border-b">
                <td className="px-4 py-3 font-medium">{col.name}</td>
                <td className="px-4 py-3">{col.product_ids?.length ?? 0}</td>
                <td className="px-4 py-3">{new Date(col.updated_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
